<ng-container *ngIf="formPrincipal">
  <div class="card-header">
    <div class="title-section">
      <h2 class="header-title">{{ modelRecived ? 'Editar Apertura' : 'Agregar Apertura' }}</h2>
    </div>
    <div class="search-section">
      <div class="button-section">
        <button class="btn-new" mat-raised-button color="accent" appPermissionControl="P133B0002" (click)="modelRecived ? update(form.value) : create(form.value)">
          <mat-icon>save</mat-icon>
          {{ modelRecived ? 'Actualizar' : 'Guardar' }}
        </button>
        <button class="btn-cancel" type="button" mat-raised-button (click)="close()" appPermissionControl="P133B0001"><mat-icon>arrow_back</mat-icon>Cancelar</button>
      </div>
    </div>
  </div>

  <form class="mt-5" [formGroup]="form" (submit)="modelRecived ? update(form.value) : create(form.value)" appPermissionControl="P133F0001">
    <div class="form-row">
      <!-- Variable -->
      <div class="form-field">
        <input id="numVar" placeholder="123" class="form-control" formControlName="numVar" type="number" [readonly]="modelRecived" required appPermissionControl="P133K0001" />
        <label>Variable</label>
      </div>

      <!-- Descripcion -->
      <div class="form-field">
        <input formControlName="descripcion" class="form-control" type="text" required appPermissionControl="P133K0002" />
        <label>Descripción</label>
      </div>

      <!-- Concepto -->
      <div class="form-field">
        <select formControlName="concepto" class="form-control" required appPermissionControl="P133K0003">
          <option value>-- Seleccione --</option>
          <option *ngFor="let concepto of conceptos" [value]="concepto.concepto">{{ concepto.concepto }} | {{ concepto.descripcion }}</option>
        </select>
        <label>Concepto</label>
      </div>

      <!-- Amortización Inferior -->
      <div class="form-field">
        <input class="form-control" formControlName="amortInf" type="number" readonly appPermissionControl="P133K0004" />
        <label>Amortización Inferior</label>
      </div>

      <!-- Amortización Superior -->
      <div class="form-field">
        <input class="form-control" placeholder="123" formControlName="amortSup" type="number" required appPermissionControl="P133K0005" />
        <label>Amortización Superior</label>
      </div>

      <!-- Porcentaje IVA -->
      <div class="form-field">
        <input class="form-control" formControlName="porcentaje" type="number" required appPermissionControl="P133K0006" />
        <label>Porcentaje IVA</label>
      </div>

      <!-- Valor Fijo -->
      <div class="form-field">
        <input class="form-control" formControlName="valorFijo" type="number" required appPermissionControl="P133K0007" />
        <label>Valor Fijo</label>
      </div>

      <!-- Forma de Pago -->
      <div class="form-field">
        <select class="form-control" formControlName="iTipoCalculo" appPermissionControl="P133K0008">
          <option value>-- Seleccione --</option>
          <option *ngFor="let element of formasPagos" [value]="element.iValor">
            {{ element.sEtiqueta }}
          </option>
        </select>
        <label>Forma de Pago</label>
      </div>
    </div>

    <div class="titleFm" style="width: 200px">FÓRMULA</div>
    <div class="content-section">
      <!-- Tasa -->
      <div class="col-4">
        <div class="form-field">
          <select class="form-control flex-grow-1" formControlName="claveTasa" appPermissionControl="P133K0009">
            <option value>-- Seleccione --</option>
            <option *ngFor="let tasa of tasas" [value]="tasa.clave">{{ tasa.clave }} | {{ tasa.descripcion }}</option>
          </select>
          <label>Tasa</label>
        </div>
      </div>

      <!-- Fórmula -->
      <div class="col-12">
        <div class="form-field">
          <input class="form-control" formControlName="formula" appPermissionControl="P133K0010" />
          <label>Fórmula</label>
        </div>
      </div>

      <div class="col-3">
        <strong>Variables:</strong>
      </div>

      <div class="col-3">
        <span><strong> K:</strong> Capital Inicial </span>
      </div>
      <div class="col-3">
        <span><strong> Y:</strong> Importe Inicial </span>
      </div>
      <div class="col-3">
        <span><strong> T:</strong> Rate </span>
      </div>
      <div class="col-3"></div>
      <div class="col-3">
        <span><strong> A:</strong> Capital Mensualidad </span>
      </div>
      <div class="col-3">
        <span><strong> I:</strong> Importe Mensualidad </span>
      </div>
      <div class="col-3">
        <span> <strong>V#:</strong> Variable Promoción </span>
      </div>
      <div class="col-3"></div>
      <div class="col-3">
        <span><strong> P:</strong> Term </span>
      </div>
      <br />
    </div>

    <div class="titleFm" style="width: 300px">CÁLCULO POR PROCEDIMIENTO</div>
    <div class="content-section">
      <div class="col-4">
        <div class="form-field">
          <label>Acción Procedimiento</label>
          <input class="form-control" formControlName="iAccion" appPermissionControl="P133K0011" />
        </div>
      </div>
    </div></form
></ng-container>
